import { Injectable, NgModule, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@Injectable()

@NgModule({
  imports: [MatDialogModule, BrowserAnimationsModule, FormsModule]
})

export class ContractService {
  myAppUrl: string = "";

  constructor(private _http: Http, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  //** Contract
  getContract(id) {
    return this._http.get(this.myAppUrl + 'api/contract/GetContract/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getContractsForDropDown() {
    return this._http.get(this.myAppUrl + 'api/contract/GetListContractsForDropDown', {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** Contract
  getContractById(id: number) {
    return this._http.get(this.myAppUrl + 'api/contract/GetContractById/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addContract(data) {
    return this._http.post(this.myAppUrl + 'api/contract/AddContract', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateContract(data) {
    return this._http.put(this.myAppUrl + 'api/contract/UpdateContract', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteContract(id) {
    return this._http.delete(this.myAppUrl + "api/contract/DeleteContract/" + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //** Contract Period
  getContractPeriods(month, year, month_flg_id, client, mac, email) {
    var cStr = (client == '' || client == "" || client == null) ? null : client;
    var mStr = (mac == '' || mac == "" || mac == null) ? null : mac;
    var eStr = (email == '' || email == "" || email == null) ? null : email;

    let data = {};
    data['month'] = month;
    data['year'] = year;
    data['month_flg_id'] = month_flg_id;
    data['client'] = cStr;
    data['mac'] = mStr;
    data['email'] = eStr;

    return this._http.post(this.myAppUrl + 'api/contract/GetListContractPeriods', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  getContractPeriodsByContract(id: number) {
    return this._http.get(this.myAppUrl + 'api/contract/GetListContractPeriodsByContract/' + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addContractPeriod(data) {
    return this._http.post(this.myAppUrl + 'api/contract/AddContractPeriod', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  updateContractPeriod(data) {
    return this._http.put(this.myAppUrl + 'api/contract/UpdateContractPeriod', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  updateContractAfterEmail(contract_period_id, remind_id, date) {
    return this._http.get(this.myAppUrl + 'api/contract/UpdateContractAfterEmail/' + contract_period_id + '/' + remind_id + '/' + date, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteContractPeriod(id) {
    return this._http.delete(this.myAppUrl + "api/contract/DeleteContractPeriod/" + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteContractPeriodByContractId(id) {
    return this._http.delete(this.myAppUrl + "api/contract/DeleteContractPeriodByContractId/" + id, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //**Email
  sendEmail(data) {
    return this._http.post(this.myAppUrl + 'api/mail/SendMail', data, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response) => response)
      .catch(this.errorHandler);

  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}  



// WEBPACK FOOTER //
// ./src/app/services/contract-service.ts